import type { GameDescriptor } from '@everyturn/engine/runtime';

export const heartsDescriptor = {
  gameId: 'hearts',
  displayName: 'Hearts',
  seats: ['north', 'east', 'south', 'west'],
  minPlayers: 4,
  maxPlayers: 4,
  defaultSeat: 'south',
  layoutId: 'hearts',
  discovery: {
    summary:
      'Pass three cards each hand, dodge penalty hearts & the Queen of Spades, or capture all 26 to Shoot the Moon.',
    family: 'Trick-Avoidance',
    playerLabel: '4 Players',
    formatLabel: 'To 100 pts (low wins)',
  },
} as const satisfies GameDescriptor;
